import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Main = styled.div`
  height: 100%;
  width: 100%;
  background-color: rgb(9, 75, 9);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
`;

const Panel = styled.div`
  height: 80%;
  width: 80%;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UpBar = styled.div`
  height: auto; /* Change height to auto to accommodate smaller screens */
  width: 100%;
  background-color: rgb(39, 167, 39);
  border-radius: 15px 15px 0px 0px;
  display: flex;
  align-items: center;
  padding: 15px;
  justify-content: space-around;
  flex-wrap: wrap; /* Allow items to wrap on smaller screens */
`;

const Elem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 11px;
  margin-bottom: 10px; /* Add margin-bottom for better spacing on smaller screens */
`;

const Box = styled.div`
  font-weight: 600;
  font-size: 20px;
  padding: 8px 16px;
  background-color: white;
  border-radius: 5px;
  color: rgb(18, 119, 57);
  flex-shrink: 0; /* Prevent items from shrinking too much */
`;

const Game = styled.div`
  flex: 1;
  width: 100%;
  border-radius: 0 0 12px 12px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const Bubble = styled.div`
  height: 40px;
  border-radius: 50%;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(73, 34, 112);
  margin: 5px;
  &:hover {
    background-color: rgb(51, 36, 68);
    cursor: pointer;
  }
`;

const BubbleText = styled.h3`
  font-weight: 500;
  font-size: 18px;
  color: #fff;
  margin: 0;
`;

function Bubblegame() {
  const [score, setScore] = useState(0);
  const [timer, setTimer] = useState(60);
  const [hit, setHit] = useState(0);
  const [bubbles, setBubbles] = useState([]);
  const [gameOver, setGameOver] = useState(false);

  const createBubble = () => {
    const bubbleArray = [];
    for (let i = 1; i <= 152; i++) {
      bubbleArray.push(
        <Bubble key={i}>
          <BubbleText>{Math.floor(Math.random() * 11)}</BubbleText>
        </Bubble>
      );
    }
    setBubbles(bubbleArray);
  };

  const runTimer = () => {
    const timerInterval = setInterval(() => {
      if (timer > 0) {
        setTimer(prevTimer => prevTimer - 1);
      } else {
        clearInterval(timerInterval);
        setGameOver(true);
      }
    }, 1000);
    return () => clearInterval(timerInterval);
  };

  const incScore = () => {
    setScore(prevScore => prevScore + 10);
  };

  const handleClick = (number) => {
    if (!gameOver && number === hit) {
      incScore();
      createBubble();
      setHit(Math.floor(Math.random() * 11));
    }
  };

  const restartGame = () => {
    setScore(0);
    setTimer(60);
    setHit(0);
    setBubbles([]);
    setGameOver(false);
    createBubble();
    runTimer();
  };

  useEffect(() => {
    alert("In this bubble game there are some bugs just ignore it! i will fix it later if i got enough time")
    setHit(Math.floor(Math.random() * 11));
    runTimer();
    createBubble();
  }, []);

  useEffect(() => {
    if (timer === 0) {
      setGameOver(true);
    }
  }, [timer]);

  return (
    <Main>
      <Panel>
        <UpBar>
          <Elem>
            <h2>Hit</h2>
            <Box>{hit}</Box>
          </Elem>
          <Elem>
            <h2>Timer</h2>
            <Box>{timer}</Box>
          </Elem>
          <Elem>
            <h2>Score</h2>
            <Box>{score}</Box>
          </Elem>
        </UpBar>
        <Game onClick={(e) => handleClick(parseInt(e.target.innerText))}>
          {gameOver ? (
            <div>
              <h2>Game Over!</h2>
              <h3>Your Score: {score}</h3>
              <button className='btn btn-outline-success' style={{width: '80px', height: '40px', fontWeight: '800'}} onClick={()=>{restartGame()}}>Restart</button>
              <Link to="/" className='btn btn-outline-success'  style={{fontWeight: '800'}}>Back</Link>
            </div>
          ) : (
            bubbles
          )}
        </Game>
      </Panel>
    </Main>
  );
}

export default Bubblegame;
